export default __webpack_public_path__ + "static/media/i_bus-jeonse_pp_tagless.66fa3824.svg";